import { escapeAttr, escapeHtml } from "@emkit/builder-core";
export const COUNTDOWN_DEFAULTS = {
    target: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    title: "Launches in",
    daysLabel: "Days",
    hoursLabel: "Hours",
    minutesLabel: "Minutes",
    secondsLabel: "Seconds",
    showSeconds: true,
    align: "center",
    digitColor: "#111827",
    labelColor: "#6b7280",
    background: "transparent",
    expiredMessage: "We're live!",
};
const ALIGN_MAP = { start: "flex-start", center: "center", end: "flex-end" };
export const countdownWidget = {
    type: "countdown",
    defaultProps: COUNTDOWN_DEFAULTS,
    renderHtml(props) {
        const align = props.align ?? "center";
        const digit = props.digitColor ?? "#111827";
        const label = props.labelColor ?? "#6b7280";
        const bg = props.background ?? "transparent";
        const showSec = props.showSeconds ?? true;
        const gid = `cd-${Math.random().toString(36).slice(2, 8)}`;
        const target = new Date(props.target).getTime();
        const targetValid = Number.isFinite(target);
        const expired = props.expiredMessage || "Done";
        const cell = (unit, lbl) => `<div class="emk-cd-cell" style="display:flex;flex-direction:column;align-items:center;gap:4px;min-width:64px"><span data-u="${unit}" style="font-size:40px;font-weight:700;line-height:1;letter-spacing:-0.02em;color:${digit};font-variant-numeric:tabular-nums">—</span><span style="font-size:12px;color:${label};text-transform:uppercase;letter-spacing:0.08em">${escapeHtml(lbl)}</span></div>`;
        const cells = [
            cell("d", props.daysLabel ?? "Days"),
            cell("h", props.hoursLabel ?? "Hours"),
            cell("m", props.minutesLabel ?? "Minutes"),
            showSec ? cell("s", props.secondsLabel ?? "Seconds") : "",
        ]
            .filter(Boolean)
            .join("");
        const title = props.title
            ? `<div style="font-size:14px;font-weight:500;color:${label};margin-bottom:16px;text-align:${align === "center" ? "center" : align};text-transform:uppercase;letter-spacing:0.08em">${escapeHtml(props.title)}</div>`
            : "";
        // Tiny inline script — bails out silently if JS is off (cells show "—").
        const script = targetValid
            ? `<script>(function(){var r=document.getElementById('${gid}');if(!r)return;var t=${target};var ex=${JSON.stringify(expired)};function p(n){return n<10?'0'+n:''+n}function tick(){var d=t-Date.now();if(d<=0){r.innerHTML='<div style="font-size:24px;font-weight:600;color:${digit};text-align:center">'+ex+'</div>';return}var s=Math.floor(d/1000);var D=Math.floor(s/86400);var H=Math.floor((s%86400)/3600);var M=Math.floor((s%3600)/60);var S=s%60;var q=r.querySelectorAll('[data-u]');q.forEach(function(e){var u=e.getAttribute('data-u');e.textContent=u==='d'?D:u==='h'?p(H):u==='m'?p(M):p(S)});requestAnimationFrame(function(){setTimeout(tick,1000)})}tick()})();</script>`
            : "";
        return `<div class="emk-countdown" style="background:${bg};padding:20px 0;font-family:inherit">${title}<div id="${escapeAttr(gid)}" style="display:flex;gap:16px;flex-wrap:wrap;justify-content:${ALIGN_MAP[align]};align-items:flex-end">${cells}</div>${script}</div>`;
    },
};
//# sourceMappingURL=countdown.js.map